__turbopack_context__.v({
  "actions": "loaded-file-item-module-scss-module__sJmBkG__actions",
  "error": "loaded-file-item-module-scss-module__sJmBkG__error",
  "filename": "loaded-file-item-module-scss-module__sJmBkG__filename",
  "icon": "loaded-file-item-module-scss-module__sJmBkG__icon",
  "root": "loaded-file-item-module-scss-module__sJmBkG__root",
  "size": "loaded-file-item-module-scss-module__sJmBkG__size",
  "title": "loaded-file-item-module-scss-module__sJmBkG__title",
});
